
























import {
  Vue,
  Component,
  Prop,
Watch
} from "@/shared/vuepack";

@Component
export default class TabGroupRouted extends Vue {
  @Prop()
  centered: boolean;

  @Prop()
  routeKeyName: string;

  tabs = [];

  created () {
    this.$on("add-tab", this.addTab);
  }

  get matchingRoute () {
    return this.$route.params[this.routeKeyName] || "";
  }

  addTab (tab) {
    tab.active = this.matchingRoute === (tab.$props.routeValue || "");
    this.tabs.push(tab);
  }

  @Watch("matchingRoute")
  onMatchingRouteChange () {
    for (const tab of this.tabs) {
      tab.active = this.matchingRoute === (tab.$props.routeValue || "");
    }
  }

  get hasTabNav () {
    return !!this.$slots["tabs-nav"];
  }

  routeForTab (tab) {
    if (typeof tab.$props.route === "function") {
      return tab.$props.route(tab);
    }

    const routeTarget = { name: this.$route.name, params: this.$route.params, query: this.$route.query };
    routeTarget.params = { ...routeTarget.params, [this.routeKeyName]: tab.$props.routeValue };
    return routeTarget;
  }
}

